/**
 * src/api/artefactApi.js
 *
 * Thin client for the artefacts-write Azure Function — the dedicated
 * per-record write path for the standalone Artefacts evidence register
 * (ADR-0009, docs/decisions/0009-artefacts-per-record-storage.md). Mirrors
 * assetApi.js's shape: one wrapper per action, each returning the function's
 * response body so callers can reconcile local state without a full reload.
 */

import { azurePost } from './azureClient';

async function callArtefactsWrite(action, body, tenantId) {
  return azurePost(`/api/artefacts-write?action=${encodeURIComponent(action)}`, {
    ...body,
    tenantId,
  });
}

/** Create-or-update an artefact by artefact.id. Returns { ok, artefact }. */
export async function saveArtefactRecord(artefact, tenantId) {
  return callArtefactsWrite('save-artefact', { artefact }, tenantId);
}

/** Delete one artefact by id. Returns { ok }. */
export async function deleteArtefactRecord(artefactId, tenantId) {
  return callArtefactsWrite('delete-artefact', { artefactId }, tenantId);
}

/** Bulk-create multiple new artefacts in one call (e.g. an email import). Returns { ok, artefacts }. */
export async function createArtefactRecords(artefacts, tenantId) {
  return callArtefactsWrite('create-artefacts', { artefacts }, tenantId);
}
